import { useEffect, useState } from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { isNativePlatform, reload } from './utils/device.util';

const NativePullToRefresh = ({ children }) => {
    const [isNative, setIsNative] = useState(false);

    useEffect(() => {
        isNativePlatform().then(setIsNative);
    }, []);

    if (!isNative) return children;

    return (
        <PullToRefresh onRefresh={reload}>
            {children}
        </PullToRefresh>
    );
};

export default NativePullToRefresh;